import { create } from 'zustand';
import apiClient from '../api/client';
import Alertas from '../alerts/AlertasGernericos';
import { TrySharp } from '@mui/icons-material';

export const useGruposStore = create((set, get) => ({

    // GET
    carregando: false,
    logado: false,
    pagina_atual: 1,
    ultima_pagina: 0,
    hanking_de_grupos: [],
    total_de_grupos_ja_vendidos: 0,
    mostrar_grafico: true,
    deletingId: 0,
    grupos: [],
    sub_grupos: [],
    filtrosDeBusca: null,

    setFiltroDeBusca: (filtros) => set({ filtrosDeBusca: filtros }),


    searchGrupos: async (filtros) => {

        set({ carregando: 'searching', pagina_atual: 1 });

        try {

            const response = await apiClient.post('/Pesquisargrupo', {
                nome: filtros.nome,
                status: filtros.status,
                cod_grupo: filtros.cod_grupo,
            });

            const { data, last_page, current_page } = response.data.dados;

            set({
                grupos: data,
                ultima_pagina: last_page,
                pagina_atual: current_page,
                carregando: 'idle'
            });

        } catch (error) {
            Alertas.ExibirAlertaErro(error.data?.message || "Não foi encotrado nenhum grupo com esses dados.");
            set({ carregando: 'idle' });
        }
    },

    fetchGrupos: async (page = 1) => {
        set({ carregando: 'fetching' });
        try {
            const response = await apiClient.get('/GetGruposPaginado', {
                params: { page }
            });

            const { data, last_page, current_page } = response.data.dados;

            set({
                grupos: data,
                ultima_pagina: last_page,
                pagina_atual: current_page,
                carregando: 'idle',
            });
        } catch (error) {
            Alertas.ExibirAlertaErro(error.response?.data?.message || "Erro ao buscar grupos.");
            set({ carregando: 'idle' });
        }
    },

    deleteGrupo: async (cod_do_grupo) => {

        set({ deletingId: cod_do_grupo }); // Mostra o loading apenas na linha a ser excluída
        try {
            const { Relaod } = get();
            let response = await apiClient.post('/ExcluirGrupo', { cod_grupo: cod_do_grupo });

            if (!response) {
                throw new Error("Ocorreu um erro de conexão, verifique se você tem acesso a internet.");
            }

            const { erro, message } = response.data;

            if (erro) {
                throw new Error(message);
            }

            // Atualiza a lista
            await Relaod();
            Alertas.ExibirAlertaSucesso(message);


        } catch (error) {
            Alertas.ExibirAlertaErro(error?.message || "Erro ao excluir grupo.");
        } finally {
            set({ deletingId: null });
        }
    },

    updateGrupos: async (grupos_data) => {

        set({ carregando: 'updating' });
        try {
            const { Relaod } = get();
            const response = await apiClient.post('/AtualizarGrupos', {
                nome: grupos_data.nome,
                status: grupos_data.status,
                cod_grupos: grupos_data.cod_grupos,
            });


            if (!response) {
                throw new Error("Ocorreu um erro de conexão, verifique se você tem acesso a internet.");
            }

            const { erro, message } = response.data;

            if (erro) {
                throw new Error(message);
            }

            // Atualiza a lista
            await Relaod();
            Alertas.ExibirAlertaSucesso(message);
            return true;

        } catch (error) {
            Alertas.ExibirAlertaErro(error.response?.data?.message || "Erro ao atualizar produto.");
            set({ carregando: 'idle' });
            return false;
        } finally {
            set({ carregando: 'idle' });
        }
    },

    CreateGrupo: async (gruposData) => {
        try {
   
            set({ carregando: 'creating' });

            const response = await apiClient.post('/CriarGrupo', {
                nome: gruposData.nome,
                status: gruposData.status,
            });

            if (!response) {
                throw new Error("Ocorreu um erro de conexão, verifique se você tem acesso a internet.");
            }

            const { erro, message } = response.data;

            if (erro) {
                throw new Error(message);
            }

            // Atualiza a lista
            await get().fetchGrupos(get().pagina_atual);
            Alertas.ExibirAlertaSucesso(message);
            set({ carregando: 'idle' });
            return true;

        } catch (error) {
            Alertas.ExibirAlertaErro(error.message || "Erro ao criar produto.");
            set({ carregando: 'idle' });
            return false;
        } finally {
            set({ carregando: 'idle' });
        }
    },

    Relaod: async () => {

        const { filtrosDeBusca, fetchGrupos } = get();

        if (filtrosDeBusca) {
            get().searchGrupos(filtrosDeBusca);
            return;
        }

        fetchGrupos(get().pagina_atual);
    }


}));
